// User validation utilities

/**
 * Validate username format and requirements
 * @param username Username to validate
 * @returns True if username is valid
 */
export function validateUsername(username: string): boolean {
	// Requirements: 2-30 characters, alphanumeric + underscore, no consecutive underscores
	if (username.length < 2 || username.length > 30) {
		return false;
	}

	// Only alphanumeric and underscore allowed
	if (!/^[a-zA-Z0-9_]+$/.test(username)) {
		return false;
	}

	// No consecutive underscores
	if (username.includes("__")) {
		return false;
	}

	// Cannot start or end with underscore
	if (username.startsWith("_") || username.endsWith("_")) {
		return false;
	}

	return true;
}

/**
 * Check if username is reserved/forbidden
 * @param username Username to check
 * @returns True if username is reserved
 */
export function isReservedUsername(username: string): boolean {
	const reserved = [
		"admin",
		"api",
		"www",
		"mail",
		"ftp",
		"localhost",
		"root",
		"support",
		"help",
		"info",
		"contact",
		"about",
		"terms",
		"privacy",
		"legal",
		"blog",
		"news",
		"press",
		"careers",
		"humble",
		"festival",
		"festivals",
		"event",
		"events",
	];

	return reserved.includes(username.toLowerCase());
}

/**
 * Suggest alternative usernames if current one is taken
 * @param baseUsername Base username to build suggestions from
 * @returns Array of suggested usernames
 */
export function suggestUsernames(baseUsername: string): string[] {
	const suggestions: string[] = [];
	const clean = baseUsername.toLowerCase().replace(/[^a-z0-9]/g, "");

	// Add numbers
	for (let i = 1; i <= 5; i++) {
		suggestions.push(`${clean}${i}`);
	}

	// Add year
	const currentYear = new Date().getFullYear();
	suggestions.push(`${clean}${currentYear}`);

	// Add random numbers
	for (let i = 0; i < 3; i++) {
		const random = Math.floor(Math.random() * 1000);
		suggestions.push(`${clean}${random}`);
	}

	return suggestions.filter(validateUsername);
}
